module.exports = __webpack_public_path__ + "static/media/icon-reports-trend.7531c8b0.svg";